import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TabPane, TabContent } from 'reactstrap';
import styled from 'styled-components';
import Well from 'components/Well';
import WindcreekTabs from 'components/WindcreekTabs';
import WindcreekTab from 'components/WindcreekTab';
import GuestInfo from '../HostBookingDetails/GuestInfo';

const GuestInfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    margin-bottom: 0;
    margin-right: 0.5em;
    margin-left: 1rem;
    margin-top: 1rem;
  }
`;

const GuestDetailsWrapper = styled(Well)`
  padding: 0;
  flex: 0 0 auto;
  min-height: 15rem;
  text-align: left;

  @media screen and (min-width: ${props => props.theme.breakpoints.large}) {
    flex: 0 0 45%;
    min-height: 45%;
    max-height: 45%;
  }
`;

const propTypes = {
  guestProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      operaProfile: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
        operaId: PropTypes.string,
        address: PropTypes.shape({
          addressLine: PropTypes.string,
          cityName: PropTypes.string,
          stateProv: PropTypes.string,
          countryCode: PropTypes.string,
          postalCode: PropTypes.string
        })
      }),
      patronBookingInfo: PropTypes.shape({
        patronAccountNumber: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        rewardsJoinDate: PropTypes.string,
        homePhone: PropTypes.string,
        mobilePhone: PropTypes.string,
        addressLine1: PropTypes.string,
        addressLine2: PropTypes.string,
        city: PropTypes.string,
        stateProv: PropTypes.string,
        postalCode: PropTypes.string
      })
    })
  )
};

const defaultProps = {
  guestProfiles: []
};

function GuestDetails({ guestProfiles }) {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <GuestDetailsWrapper className="guest-info-container">
      <GuestInfoHeader>
        {!guestProfiles || (guestProfiles.length === 0 && <h5>Guest Info</h5>)}
        {guestProfiles && guestProfiles.length > 1 && (
          <WindcreekTabs>
            {guestProfiles.map((guest, i) => (
              <WindcreekTab
                key={guest.operaProfile.operaId}
                className={activeTab === i ? 'active' : ''}
                onClick={() => setActiveTab(i)}
              >
                Guest {i + 1}
              </WindcreekTab>
            ))}
          </WindcreekTabs>
        )}
      </GuestInfoHeader>
      {guestProfiles ? (
        <React.Fragment>
          {guestProfiles.length > 1 ? (
            <React.Fragment>
              {guestProfiles.map((guest, i) => (
                <TabContent
                  activeTab={activeTab}
                  key={guest.operaProfile.operaId}
                >
                  <TabPane tabId={i}>
                    <GuestInfo guest={guest} />
                  </TabPane>
                </TabContent>
              ))}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {guestProfiles.map(guest => (
                <GuestInfo guest={guest} />
              ))}
            </React.Fragment>
          )}
        </React.Fragment>
      ) : (
        <p>Enter rewards account number of guest</p>
      )}
    </GuestDetailsWrapper>
  );
}

GuestDetails.propTypes = propTypes;
GuestDetails.defaultProps = defaultProps;

export default GuestDetails;
